import React from 'react';

import PageTemplate from '../../components/template/PageTemplate';
import ProductDetailWrap from '../../views/product/detail/ProductDetailWrap';
import usePrepareInsertProduct from '../../hooks/queries/product/usePrepareInsertProduct';
import useToastMsg from '../../hooks/common/useToastMsg';
import { INIT_PRODUCT_DETAIL_MODEL } from '../../store/modules/product/models';
import productToastMsg from '../../constants/service/toastMsg/productToastMsg';
import { PRODUCT_DETAIL_PAGE_TYPE, PRODUCT_PAGE_NAME } from '../../constants/service/app/productConstants';
import { extractErrorMessage } from '../../lib/utils/checkErrorResponse';

const ProductCreate = () => {
  const toastMsg = useToastMsg();
  const { data } = usePrepareInsertProduct({
    initialData: INIT_PRODUCT_DETAIL_MODEL,
    onSuccess: () => {
      toastMsg.success(productToastMsg.PREPARE_INSERT_PRODUCT_REQUEST_SUCCESS);
    },
    onError: (error) => {
      toastMsg.error(extractErrorMessage(error));
    },
  });

  return (
    <PageTemplate pageName={PRODUCT_PAGE_NAME.PRODUCT_CREATE}>
      <ProductDetailWrap pageType={PRODUCT_DETAIL_PAGE_TYPE.CREATE} data={data} />
    </PageTemplate>
  );
};

export default ProductCreate;
